import api from 'api'

export type CancelBonusRequest = {
  userPaymentId: number
  comment: string
}

export type CancelBonusResponse = {
  userPaymentId: number
  amount: number
}

export const cancelBonus = async (
  request: CancelBonusRequest
): Promise<CancelBonusResponse> => {
  const response = await api.post('/admin/payment/cancel_bonus', request)
  return response.data
}
